export default __webpack_public_path__ + "static/media/five.0912d05b.png";